// export const backendURL = import.meta.env.REACT_APP_API_URL || 'http://localhost:5000';

// export const backendURL = process.env.REACT_APP_API_URL;

export const backendURL =
  process.env.REACT_APP_API_URL || "http://localhost:5000";